import { memo } from 'react';

import {
  FileStatusButton,
  FileStatusIconProgressing,
  FileStatusSubtitle,
  FileStatusTitle,
} from '@air/feature-file-status/ui';
import { Close } from '@air/next-icons';

import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';

export type AssetCustomFieldValueUpdateTaskInProgressPanelItemProps = {
  onCancel: () => void;
};

export const AssetCustomFieldValueUpdateTaskInProgressPanelItem = memo(
  ({ onCancel }: AssetCustomFieldValueUpdateTaskInProgressPanelItemProps) => {
    return (
      <PaneItemTW
        avatar={<FileStatusIconProgressing />}
        title={
          <FileStatusTitle data-testid="ASSET_CUSTOM_FIELD_VALUE_UPDATE_TASK_IN_PROGRESS_PANEL_ITEM_TITLE">
            Updating custom fields
          </FileStatusTitle>
        }
        subtitle={<FileStatusSubtitle className="truncate">Your changes will be applied shortly.</FileStatusSubtitle>}
        buttons={
          <FileStatusButton label="Cancel" onClick={onCancel}>
            <Close className="size-4" />
          </FileStatusButton>
        }
      />
    );
  },
);

AssetCustomFieldValueUpdateTaskInProgressPanelItem.displayName = 'AssetCustomFieldValueUpdateTaskInProgressPanelItem';
